<template>
  <div :class="$style.root">
    <div
      :class="[$style.button, { [$style.active]: !isCm }]"
      @click="setIsCm(false)"
    >
      IN
    </div>
    <div
      :class="[$style.button, { [$style.active]: isCm }]"
      @click="setIsCm(true)"
    >
      CM
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["isCm"]),
  },
  methods: {
    ...mapMutations(["setIsCm"]),
  },
};
</script>

<style lang="scss" module>
.root {
  display: inline-flex;
  margin: auto;
  border: 1px solid rgb(0, 0, 0);
  border-radius: 10px;
  font-size: small;
}

.button {
  display: block;
  width: 50%;
  border-radius: 10px;
  padding: 5px 15px;
  color: #333;
  cursor: pointer;
}

.active {
  color: #fff;
  background-color: rgb(0, 0, 0);
}
</style>